// These are the constants for the common styles of the components
// Updated to work for both individual inputs and containers
export const focusVisibleRing =
  'focus-visible:ring-primary focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none has-[[data-slot=input-group-control]:focus-visible]:ring-2 has-[[data-slot=input-group-control]:focus-visible]:ring-primary has-[[data-slot=input-group-control]:focus-visible]:ring-offset-2';

// `ring-destructive/20` only sets a ring colour, so without a border the invalid state was
// invisible unless focused. Matches badge/checkbox/toggle and the shadcn default.
export const focusVisibleRingError =
  'aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-invalid:has-[input:focus-visible]:ring-destructive/20';

export const invalidRing = 'border-destructive ring-1 ring-destructive/20';

/**
 * Native input attributes that tell the browser and password managers this is a
 * search/filter box, not a credential field. Spread onto any search or filter input
 * that a password manager mistakes for a login and decorates with a fill icon or a
 * "save password" prompt: `<Input {...PREVENT_AUTOFILL_PROPS} />`.
 * These are all standard DOM attributes — nothing bespoke — so they flow through
 * the component's normal `{...props}` passthrough.
 */
export const PREVENT_AUTOFILL_PROPS = {
  autoComplete: 'off', // Browser native: do not offer autofill or saved-value suggestions.
  autoCorrect: 'off', // Safari/iOS: do not auto-correct typed search text.
  autoCapitalize: 'off', // Mobile keyboards: do not capitalize the first letter of a query.
  spellCheck: false, // No red squiggles under partial search terms.
  'data-1p-ignore': true, // 1Password: skip this field, no inline fill icon.
  'data-lpignore': 'true', // LastPass: skip this field.
  'data-bwignore': true, // Bitwarden: skip this field.
  'data-form-type': 'other', // Dashlane: mark as non-login so it is not treated as a credential.
} as const;
